import { useQuery } from "@apollo/client";
import {
  Box,
  Divider,
  Flex,
  HStack,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Navigate, useParams } from "react-router-dom";
import { ComponentLoading } from "../../../components/loading/ComponentLoading";
import { ReviewedUrlType } from "../../../graphql/generated";
import { GET_REVIEWED_URL } from "../../../graphql/operations/campaignOperations/operations";
import { decodeURL } from "../../../utils/encodeUrl";
import { TitleLink } from "../TitleLink";
import { ClassificationsGroup } from "./ClassificationsGroup";

export const PastReview = () => {
  const url = decodeURL(useParams().url || "");

  const { data, loading, error } = useQuery(GET_REVIEWED_URL, {
    skip: !url,
    variables: {
      url: url,
    },
    fetchPolicy: "cache-and-network",
  });

  // const {
  //   data: dataOriginal,
  //   loading: loadingOriginal,
  //   error: errorOriginal,
  // } = useQuery(GET_URL_CLASSIFICATION, {
  //   skip: !url,
  //   context: { clientName: "hitlEndpoint" },
  //   variables: {
  //     redisKey: url,
  //   },
  //   fetchPolicy: "cache-and-network",
  // });

  if (loading) {
    return <ComponentLoading text={"Loading URLs..."} />;
  }

  if (error || !url) {
    return <>Error</>;
  }

  if (!data) {
    return <Navigate to={"/human-in-the-loop"} />;
  }

  const reviewedUrl: ReviewedUrlType = data.reviewedUrl;

  const createdAt = new Date(reviewedUrl.createdAt);
  const createdAtDate = createdAt.toLocaleDateString("en-GB");
  const createdAtTime = createdAt.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  // const originalClassification: UrlClassificationType =
  //   dataOriginal.urlClassification;

  // data check for orginal classification if it doesnt exist then it doesnt carry out the ClassificationsGroup component
  // if (
  //   !originalClassification.pageUrl ||
  //   originalClassification.pageUrl === null
  // ) {
  //   originalClassificationAvailable = false;
  // }

  return (
    <Box mg={2}>
      <Flex
        bgColor={"white"}
        borderRadius={"lg"}
        p={4}
        mb={10}
        direction={"column"}
        w={"100%"}
      >
        <TitleLink
          showNote={false}
          url={url}
          reviewButton={false}
          predictiveCorrections={false}
          correctionButton={false}
          showLink={true}
        />

        <Box mx={4} width={"100%"}>
          <HStack>
            <Text as={"span"} fontWeight={"bold"}>
              {`Reviewed by`}
            </Text>
            <Text as={"span"}>
              {`${reviewedUrl.reviewedBy.firstName} ${reviewedUrl.reviewedBy.lastName}`}
            </Text>
            <Text as={"span"} fontWeight={"bold"}>
              {`on`}
            </Text>
            <Text as={"span"}>{`${createdAtDate}-${createdAtTime}`}</Text>
          </HStack>
          <Divider borderColor={"muted"} mb={4} w={"98%"} />
          <Stack direction={{ base: "column", md: "row" }} spacing={4} mt={4} w="97%">
            {reviewedUrl.reviewedClassification && (
              <Box
                flex="1"
                mb={4}
              >
                <ClassificationsGroup
                  classification={reviewedUrl.reviewedClassification}
                  classicationType={"Accepted"}
                />
              </Box>
            )}
            {reviewedUrl.rejectedClassification && (
              <Box
                flex="1"
                mb={4}
              >
                <ClassificationsGroup
                  classification={reviewedUrl.rejectedClassification}
                  classicationType={"Rejected"}
                />
              </Box>
            )}
          </Stack>
          <Divider borderColor={"muted"} mt={4} mb={4} w={"98%"} />
          <Box mr={10}>
            {reviewedUrl.originalClassification&& (
              <ClassificationsGroup
                classification={reviewedUrl.originalClassification}
                classicationType={"Original"}
              />
            )}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

